'use strict';

import React from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/FrontOffice'

import FrontAuthCentered from '@/Wrapper/FrontAuthCentered'

import RegistrationForm from '@/Form/RegistrationForm'

import Image from '@Pure/Image'

export default PageWrapper(function RegistrationPage (props)
{
	return (
		<Layout page_title="Inscription">

			<FrontAuthCentered>

				<div className="home-form registration">

					<div className="home-form__img-container">
						<Image className="home-form__img"
							src="/images/background/accueil_synergies@1500.jpg" />
					</div>

					<RegistrationForm className="c-form form-registration"
						history={ props.history }
					/>

				</div>

			</FrontAuthCentered>

		</Layout>
	);
});
